'use client';

import type { ReactNode } from 'react';
import { NextIntlClientProvider } from 'next-intl';
import main from '@/messages/ja-JP.json';
import club from '@/messages/club/ja-JP.json';
import federation from '@/messages/federation/ja-JP.json';

// Static imports inside a client module: the bundle ships as a cached JS chunk,
// not as RSC props serialised into every page (see src/i18n/client/index.ts).
const messages = { ...main, ...club, ...federation };

export default function jaJPMessages({ children }: { children: ReactNode }) {
  return (
    <NextIntlClientProvider messages={messages} locale="ja-JP" timeZone="Australia/Sydney">
      {children}
    </NextIntlClientProvider>
  );
}
